import { MapMutationCodes } from '@/store/modules/map/mutations';
import { LayerDetailsService } from '@/services/layer-details-service';
import { createLayer } from '@/services/map-services/layers';
import '@/services/map-services/ol-map-extensions';
import '@/services/map-services/ol-layer-extensions';
const layerDetailsService = new LayerDetailsService();
export const actions = {
    async zoom({ state }, index) {
        state.ol.view.setZoom(state.ol.view.getZoom() + index);
    },
    async home({ state }) {
        state.ol.view.setZoom(state.ol.home.zoom);
        state.ol.view.setCenter(state.ol.home.center);
    },
    async resetSelection({ state }) {
        state.ol.selectionLayer?.getSource()?.clear();
    },
    async addLayer({ state, commit }, resource) {
        const exists = state.layers.find((layer) => {
            return layer.id === resource.id;
        });
        if (exists === undefined) {
            const layerDetailsResult = await layerDetailsService.Get(resource.id);
            if (layerDetailsResult.err)
                console.log(layerDetailsResult.val);
            if (layerDetailsResult.ok) {
                commit(MapMutationCodes.ADD_LAYER_TO_CATALOG, layerDetailsResult.val);
            }
        }
    },
    async removeLayer({ commit }, layer) {
        commit(MapMutationCodes.REMOVE_LAYER_FROM_CATALOG, layer);
    },
    async activateSidetray({ commit }, menuItem) {
        commit(MapMutationCodes.SET_SIDETRAY_TITLE, menuItem);
        commit(MapMutationCodes.SET_SIDETRAY_ACTIVE, true);
    },
    async deactivateSidetray({ commit }) {
        commit(MapMutationCodes.SET_SIDETRAY_ACTIVE, false);
    },
    async activateBottomDrawer({ commit }, title) {
        commit(MapMutationCodes.SET_BOTTOM_DRAWER_TITLE, title);
        commit(MapMutationCodes.SET_BOTTOM_DRAWER_ACTIVE, true);
    },
    async deactivateBottomDrawer({ commit }) {
        commit(MapMutationCodes.SET_BOTTOM_DRAWER_ACTIVE, false);
    },
    async setBasemap({ commit }, layer) {
        commit(MapMutationCodes.SELECT_BASEMAP, layer);
    },
    async init({ state, commit }) {
        commit(MapMutationCodes.SET_MAP_OBJECT, state.basemaps);
    },
    async addMapLayer({ state }, layer) {
        if (state.ol.map === undefined)
            return;
        const mapLayer = createLayer(layer);
        if (mapLayer.ok) {
            mapLayer.val.setZIndex(0);
            state.ol.layers.push(mapLayer.val);
            state.ol.map.addLayer(mapLayer.val);
        }
    },
    async setMapLayers({ state }, layers) {
        if (state.ol.map === undefined)
            return;
        state.ol.map.addLayer(state.ol.selectionLayer);
        layers
            .slice()
            .reverse()
            .forEach((layer, index) => {
            const mapLayer = createLayer(layer);
            if (mapLayer.ok) {
                mapLayer.val.setZIndex(index);
                state.ol.layers.push(mapLayer.val);
                state.ol.map.addLayer(mapLayer.val);
            }
        });
    },
    async updateDrawOrder({ state, commit }, layers) {
        if (state.ol.map === undefined)
            return;
        console.log(state.layers);
        state.layers = layers;
        console.log(state.layers);
        layers
            .slice()
            .reverse()
            .forEach((layer, index) => {
            const mapLayerResult = state.ol.map.FindLayerById(layer.id);
            if (mapLayerResult.ok) {
                mapLayerResult.val.set('drawOrder', index);
                mapLayerResult.val.setZIndex(index);
            }
        });
    },
    async updateTimeQueries({ state, commit }, date) {
        if (state.ol.map === undefined)
            return;
        let queryString = '';
        state.ol.layers.forEach((layer, index) => {
            let timeEnabledLayer = false;
            let dateTimes = {};
            Object.entries(layer.get('required_parameters')).filter(([key, value]) => {
                if (value.type === 'timestamp') {
                    dateTimes[key] = value.defaultValue;
                    timeEnabledLayer = true;
                }
            });
            if (timeEnabledLayer) {
                const keys = Object.keys(dateTimes);
                if (keys.length === 2) {
                    const values = Object.values(dateTimes);
                    const startKey = keys.find((x) => new Date(dateTimes[x]).getTime() ===
                        Math.min.apply(null, values.map((d) => new Date(d).getTime()))) || '';
                    const endKey = keys.find((x) => new Date(dateTimes[x]).getTime() ===
                        Math.max.apply(null, values.map((d) => new Date(d).getTime()))) || '';
                    const interval = new Date(dateTimes[endKey]).getTime() - new Date(dateTimes[startKey]).getTime();
                    queryString = `${layer.get('DistributionURL')}?${startKey}=${date.toISOString().substring(0, 19)}&${endKey}=${new Date(date.getTime() + interval)
                        .toISOString()
                        .substring(0, 19)}`;
                }
                else if (keys.length === 1) {
                    queryString = `${layer.get('DistributionURL')}?${keys[0]}=${date.toISOString().substring(0, 19)}Z`;
                }
                else {
                    console.log('No timestamp field found!');
                }
                layer.getSource().refresh();
                layer.getSource().setUrl(queryString);
            }
        });
    },
    async setAttributeTable({ state }, layer) {
        // @ts-ignore
        const extent = state.ol.view.calculateExtent(state.ol.map.getSize());
        // @ts-ignore
        state.bottomDrawer.attributeTableResult = layer.GetDataTable(extent);
    },
    async updateMapTarget({ commit }, target) {
        // @ts-ignore
        commit(MapMutationCodes.UPDATE_MAP_TARGET, target);
    },
};
